module.exports = __webpack_public_path__ + "static/media/favicon.9c9a7508.ico";